import { yupResolver } from '@hookform/resolvers/yup'
import React, { useContext } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { cleanerSchema } from '../../util/validationSchema'
import { SpinnerContext } from '../../context/spinnerContext'
import { errorToast, successToast } from '../../util/Toast/toast'
import { editCleaner } from '../../redux/slices/cleanersSlice'
import { useDispatch } from 'react-redux'
import { capitalizeFirstLetter, formatPhoneNumbertoString, maskPhoneNumber } from '../../helper/function'
import InputMask from 'react-input-mask'

const EditCleaner = ({ editCleanerData, toggle, setIsRefresh }) => {
  const { changeLoader } = useContext(SpinnerContext)
  const dispatch = useDispatch()

  const {
    handleSubmit,
    control,
    trigger,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(cleanerSchema),
    defaultValues: {
      first_name: editCleanerData?.first_name || '',
      last_name: editCleanerData?.last_name || '',
      phone_number: maskPhoneNumber(editCleanerData?.phone_number)
    }
  })

  const onSubmit = (data) => {
    setIsRefresh(false)
    changeLoader(true)
    if (editCleanerData) {
      const payloaddata = {
        data: { ...data, phone_number: formatPhoneNumbertoString(data?.phone_number) },
        cleaner_id: editCleanerData?.cleaners_id
      }
      dispatch(editCleaner(payloaddata))
        .then(({ payload, error }) => {
          if (payload?.status === 200) {
            toggle()
            changeLoader(false)
            setIsRefresh(true)
            successToast(payload?.data?.status_message || 'Success!')
          } else {
            errorToast(payload?.data?.status_message || error?.message)
            changeLoader(false)
          }
        })
        .catch(() => {
          changeLoader(false)
        })
    }
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="card-body add-vendor pb-4">
              <div className="form-group-item border-0 pb-0 mb-0">
                <div className="row">
                  <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                      <label>
                        First Name<span className="text-danger"> *</span>
                      </label>
                      <Controller
                        name="first_name"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control"
                              value={value}
                              type="text"
                              placeholder="Enter Name"
                              onChange={(val) => {
                                const input = val.target.value
                                const capitalized = capitalizeFirstLetter(input)
                                onChange(capitalized)
                                trigger('first_name')
                              }}
                            />
                            <small>{errors.first_name?.message}</small>
                          </>
                        )}
                        defaultValue=""
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                      <label>
                        Last Name<span className="text-danger"> *</span>
                      </label>
                      <Controller
                        name="last_name"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control"
                              value={value}
                              type="text"
                              placeholder="Enter Name"
                              onChange={(val) => {
                                const input = val.target.value
                                const capitalized = capitalizeFirstLetter(input)
                                onChange(capitalized)
                                trigger('last_name')
                              }}
                            />
                            <small>{errors.last_name?.message}</small>
                          </>
                        )}
                        defaultValue=""
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 col-12">
                    <div className="form-group input_text">
                      <label>
                        Contact <span className="text-danger"></span>
                      </label>
                      <Controller
                        name="phone_number"
                        type="text"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <InputMask
                            mask="(999) 999-9999" // Mask format
                            value={value}
                            onChange={onChange}
                            className={`form-control ${errors?.phone_number ? 'error-input' : ''}`}
                            placeholder="Enter Phone Number"
                            autoComplete="off"
                          >
                            {(inputProps) => <input {...inputProps} />}
                          </InputMask>
                        )}
                        defaultValue=""
                      />
                      <small>{errors?.phone_number?.message}</small>
                    </div>
                  </div>
                </div>
              </div>

              <div className="multi_btn_div">
                <button type="button" className="btn common-outline-btn w-100" onClick={() => toggle()}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary common-field-btn w-100">
                  Update
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default EditCleaner
